import React from "react";

import DashboardShell from "../dashboard/DashboardShell";

const Dashboard = () => (
  <DashboardShell
    title="Regions"
    subtitle="Content footprint across every continental region."
    clickRoute="/region"
    breadCrumbDefault={false}
  />
);

export default Dashboard;
